import { AxiosError } from "axios";
import { RootState } from "../store";
import { Plugin } from 'vuex';
import { WEBSOCKET_EVENTS } from '../modules/websocket/websocket.types';
import { notificationService } from '../../utils/notification.service';

export const showSessionExpiredMessage = () => {
    notificationService.showSessionExpiredNotification();
};

export const redirectToProxy = (showMessage: boolean = false) => {
    if (showMessage) {
        showSessionExpiredMessage();
        // Add a small delay to ensure the notification is shown before redirect
        setTimeout(() => {
            window.location.replace(`${process.env.VUE_APP_PROXY_CLIENT_URL}`);
        }, 3500); // Slightly longer than the notification duration
    } else {
        window.location.replace(`${process.env.VUE_APP_PROXY_CLIENT_URL}`);
    }
};

export const checkProjectIdAndRedirect = (projectId: string | undefined) => {
    if (!projectId || projectId === 'undefined' || projectId === 'null') {
        console.warn('Missing or invalid projectId, redirecting to proxy');
        redirectToProxy();
        return true; // Indicates redirect happened
    }
    return false; // No redirect needed
};

// 403 - Forbidden
// 401 - Unauthorized
// 419 - Session Expired
export const badResponseStatus = [403, 401, 419];

const handleWebSocketError = (store: any) => {
    // Listen for ACCOUNT_DETAILS_ERROR_EVENT mutations
    store.subscribe((mutation: any) => {
        if (mutation.type === 'websocket/WS_UPDATE_EVENT_STATE' && 
            mutation.payload?.event === WEBSOCKET_EVENTS.ACCOUNT_DETAILS_ERROR_EVENT) {
            // Show session expired message for WebSocket errors too
            redirectToProxy(true);
        }
    });
};

export const badResponseHandlerPlugin: Plugin<RootState> = store => {
    // Handle HTTP errors
    store.subscribe(mutation => {
        const error: AxiosError = mutation.payload?.error;
        if (!error) { return; }
        const status = error?.response?.status as number;
        if (error && status && badResponseStatus.includes(status)) {
            // Show session expired message for 419 (Session Expired) errors
            const showMessage = status === 419;
            redirectToProxy(showMessage);
        }
    });

    // Handle WebSocket errors
    handleWebSocketError(store);
};